// extracted by mini-css-extract-plugin
module.exports = {"contCards":"Paginado_contCards__3Thhz","pageNumbers":"Paginado_pageNumbers__1FWlu","active":"Paginado_active__18aw4","pokeball":"Paginado_pokeball__QLbcZ"};